import React, { FC } from 'react';
import { BodyTextSmall, Button, HeadingText40, Modal } from '@modernhealth/vital-components';
import { colors } from '@modernhealth/vital-foundation';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';

export enum CancelSessionConfirmationModalTestID {
    BackButton = 'CancelSessionConfirmationModalTestID.BackButton',
    ConfirmButton = 'CancelSessionConfirmationModalTestID.ConfirmButton',
}

type Props = {
    isLoading: boolean;
    isVisible: boolean;
    onBack: () => void;
    onConfirm: () => void;
};

export const CancelSessionConfirmationModal: FC<Props> = ({
    isLoading,
    isVisible,
    onBack,
    onConfirm,
}) => {
    const { t } = useTranslation();

    return (
        <Modal isVisible={isVisible} maxWidth={500} onCloseButtonClick={onBack}>
            <Title fontColor="gray85">
                {t('videoSessions:session_details.cancel_confirmation.title')}
            </Title>

            <Body fontColor="gray85" marginTop={8}>
                {t('payments:cancel_session_confirmation_modal.description')}
            </Body>

            <ButtonContainer>
                <BackButton
                    disabled={isLoading}
                    fluid
                    onClick={onBack}
                    size="large"
                    data-testid={CancelSessionConfirmationModalTestID.BackButton}
                    variant="secondary"
                >
                    {t('dashboard:button_back')}
                </BackButton>
                <CancelButton
                    fluid
                    busy={isLoading}
                    onClick={onConfirm}
                    size="large"
                    data-testid={CancelSessionConfirmationModalTestID.ConfirmButton}
                >
                    {t('videoSessions:session_details.cancel')}
                </CancelButton>
            </ButtonContainer>
        </Modal>
    );
};

const Title = styled(HeadingText40)({
    textAlign: 'center',
});

const Body = styled(BodyTextSmall)({
    textAlign: 'center',
});

const ButtonContainer = styled.div({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    marginTop: 16,
});

const BackButton = styled(Button)({
    marginRight: 8,
});

const CancelButton = styled(Button)({
    backgroundColor: colors.red40,
    borderColor: colors.red40,
    color: colors.white,
    marginLeft: 8,
});
